import { Injectable      } from '@angular/core';
import { UtilsManager    } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier        } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager  } from 'src/app/managers/request/request.manager';
import { ErrorManager    } from 'src/app/managers/error/error.manager';
import { Dashboard       } from 'src/app/beans/dashboard/dashboard';

@Injectable
({
  providedIn: 'root'
})

export class ProgressHandler
{
    constructor
    (
      private _utils    : UtilsManager    ,
      private _notifier : NotifierManager ,
      private _request  : RequestManager  ,
      private _error    : ErrorManager    ,
    ) {}

    async get( token: string, siteId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if (!this._utils.checker().isValidId( siteId )){
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.progress().get( token, siteId ).toPromise()

          if (this._error.hasError( response ))
          {
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }
          
          return response

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }

    async update( token: string, siteId: number, callModeId: number )
    {      
        if (!this._utils.checker().isValidText( token )) 
        {
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_PASSWORD
          )
          return undefined
        } 

        if (!this._utils.checker().isValidId( siteId )){
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_SITE_ID
          )
          return undefined
        }

        //Control callModeId
        if (!this._utils.checker().isValidId( callModeId )){
          this._notifier.show( 
            Notifier.WARNING, 
            NotifierMessage.INVALID_CALLMODE_ID
          )
          return undefined
        }

        try
        {
          const response = await this._request.progress().update( token, siteId, callModeId ).toPromise()

          if (this._error.hasError( response )){
            // MANAGE ERROR
            return this._error.handleCQWebapp ( response )
          }
          else
          {
            this._notifier.show
            ( 
              Notifier.SUCCESS            , 
              NotifierMessage.OPERATION_OK,
            )
            return response
          }

        }catch( error )
        {
          // this._error.handleNetwork ( error )  
          return undefined
        }
    }
}

